import { IDropDownItem } from '../../baseComponents/DropDown';

export const NOT_FOUND = -1;
export const EMPTY_DROPDOWN_ITEM: IDropDownItem = { name: '', id: NOT_FOUND };
export const EMPTY_STRING = '';
